module.exports = __webpack_public_path__ + "img/inco4Ac.3cee228d.png";